<script>
export default {
  name: "WhyXiyue"
}
</script>

<template>
<div align="center">
  <h1>Why Make Your Custom Packaging with XIYUE?</h1>
  <b-card-sub-title style="font-size: x-large">Don’t Just Ship. Make an Impression.</b-card-sub-title>
  <b-card class="overflow-hidden border-0 rounded-0 bg-light" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
    <b-row no-gutters align-v="center">
      <b-col md="3">
        <b-card-img-lazy src="@/assets/6-5.jpg"></b-card-img-lazy>
      </b-col>
      <b-col md="9">
        <b-card-body style="margin-left: 20px">

          <b-card-text class="text-left" style="font-size: larger">
            The true partnership goes beyond a quote. While many suppliers promise boxes, XIYUE delivers brand
            elevation
            through precision craft and strategic insight.We begin by listening—deeply—to your vision, challenges,
            and
            market. Then, through a seamlessly integrated process, we translate that understanding into tangible
            brand
            advantage:
            <ul>
              <li>Shelf Impact, Engineered: We design for the first three seconds—combining structure, finish, and
                visual clarity to stop glances and ignite desire.
              </li>
              <li>End-to-End Excellence: From material sourcing to final delivery, every step is governed by the
                same
                standard: yours.
              </li>
              <li>An Extension of Your Team: We don’t just take orders—we collaborate, advise, and problem-solve as
                your
                dedicated packaging partner.
              </li>
              <li>Your packaging is your silent ambassador. It should speak with your voice, reflect your standards,
                and
                elevate your presence.
              </li>
            </ul>
            Let’s build more than a box. Let’s build your brand image.
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</div>
</template>

<style scoped lang="scss">

</style>